import Card, { CardContent, CardDescription, CardTitle } from '@/components/elements/Card';
import { LinkRenderer } from '@/components/elements/Link';
import Container from '@/components/global/Container';
import Grid from '@/components/global/Grid';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentSharedLink, IComponentSharedTitleAndDescription, IContactColumnsFragment, IContactsBlockFragmentFragment } from '@/graphql/__generated__/global/types';
import LinkArrow from '@/icons/LinkArrow';
import classNames from '@/lib/classNames';
import { TRACKING_EVENT, track } from '@/lib/gtm';
import { useRouter } from 'next/router';

const Column = ({ title, links, numCols }: IContactColumnsFragment & { numCols: number }) => {
    const router = useRouter();

    const multipleLinks = links.length > 1;
    const hoistSingleLinkTitle = !multipleLinks && (title.length == 0 || title.match(/^(\.|_| )$/));
    const [desktopSpan, mobileSpan] = [12 / numCols, 6 / numCols];
    return (
        <Card className={classNames('col-span-6', `md:col-span-${mobileSpan}`, `xl:col-span-${desktopSpan}`, 'bg-shell/50 min-h-0 text-primary')}>
            <CardContent spacing="between">
                {!hoistSingleLinkTitle && <CardTitle>{title}</CardTitle>}
                {links && (
                    <div className={`w-full grid gap-5 grid-cols-1 ${!hoistSingleLinkTitle && 'mt-4 md:mt-16'}`}>
                        {links?.map((l, i) => (
                            <LinkRenderer
                                key={i}
                                className="group relative"
                                rel="noopener noreferrer"
                                {...(l.link as IComponentSharedLink)}
                                onClick={() =>
                                    track(TRACKING_EVENT.CONTACT_LINK, {
                                        label: l.link?.label ?? '',
                                        page: router.asPath,
                                    })
                                }
                            >
                                <CardTitle as={!hoistSingleLinkTitle ? 'h4' : 'h3'} className="mb-0">
                                    {l.title}
                                </CardTitle>
                                <div className="flex items-center justify-between">
                                    <CardDescription className="p large">{l.link.label}</CardDescription>
                                    <LinkArrow className="ml-1" />
                                </div>
                            </LinkRenderer>
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

const ContactColumns = ({ titleDescription, columns }: IContactsBlockFragmentFragment) => {
    return (
        <Container>
            {titleDescription && <TitleAndDescription className="pb-8" {...(titleDescription as IComponentSharedTitleAndDescription)} />}

            <Grid>
                {columns?.map((c, i) => (
                    <Column numCols={columns.length} key={i} {...c} />
                ))}
            </Grid>
        </Container>
    );
};

export default ContactColumns;
